<template>
  <generic-error no-appbar>
    <template v-slot:title>Erreur dans l'URL</template>
    <h1>Accès non autorisé</h1>
    <p>Le formulaire que vous tentez d’accéder, est bloqué.</p>
    <p>Les causes possibles peuvent être :</p>
    <ol>
      <li>
        Vous devez être connecté et dans ce cas, utilisez le bouton SE CONNECTER ou la
        fonction CRÉATION DE COMPTE si vous n’avez pas de compte;
      </li>
      <li>
        Le formulaire nécessite un prérequis non respecté.<br />
        Par exemple, pour le formulaire d’abonnement au Service de référence, vous ne
        pouvez pas :
        <ul>
          <li>être membre à la retraite ou hors-Québec;</li>
          <li>ne pas avoir de bureau en pratique privée;</li>
          <li>avoir un dossier de discipline ouvert.</li>
        </ul>
      </li>
    </ol>
  </generic-error>
</template>

<script>
import GenericError from "./GenericError"
export default {
  components: {
    GenericError
  }
}
</script>

<style>
</style>
